import React from 'react';
import { Body, Headline, Icon, LinkButton } from '@sato/components';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { Link } from '@components/common/Link';
import { SatoFIRoute } from '@routes/routes.constants';
import { localizationStore, t } from '@stores/localization';
import satoFiUtils from '@utils/satoFi.utils';

type Props = {
  className?: string;
};

/** A banner with a link to sato-fi apartment search watch */
export const ApartmentSearchWatchBanner = observer(({ className }: Props) => (
  <div
    className={classNames(
      'flex flex-col items-center gap-4 text-center md:flex-row md:gap-5 md:text-left',
      'rounded-sm bg-brand-secondary-light p-4 mdDown:px-3',
      className
    )}
  >
    <div className="rounded-[1.75rem] bg-brand-accent-red text-white">
      <Icon
        icon="sendNew"
        className="m-3 h-6 w-6 md:h-[3.75rem] md:w-[3.75rem]"
      />
    </div>

    <div className="flex-1">
      <Headline level={3} className="mb-2">
        {t('apartmentSearchWatchBanner.title')}
      </Headline>

      <Body className="leading-relaxed">
        {t('apartmentSearchWatchBanner.body')}
      </Body>
    </div>

    <LinkButton
      linkComponent={Link}
      to={satoFiUtils.getSatoFIUrl(SatoFIRoute.URL_SEARCH_ALERT, {
        language: localizationStore.language,
      })}
      className="mdDown:w-full"
    >
      {t('apartmentSearchWatchBanner.cta')}
    </LinkButton>
  </div>
));
